
function DesktopFooter() {
    return (
        <div className={"pw bg-black bg-opacity-10 w-full mx-auto mt-8"}>
            <div id="desktop-bottom-leaderboard" className="pw-ph-leaderboard" />
        </div>
    )
}

export default DesktopFooter;